export const trackingAttributes = (trackingCat, trackingId) => [trackingCat, trackingId];
//# sourceMappingURL=buildTrackingAttributes.js.map